import { render, staticRenderFns } from "./accountForm.vue?vue&type=template&id=5199e3e2&scoped=true"
import script from "./accountForm.vue?vue&type=script&lang=js"
export * from "./accountForm.vue?vue&type=script&lang=js"
import style0 from "./accountForm.vue?vue&type=style&index=0&id=5199e3e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199e3e2",
  null
  
)

export default component.exports